import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { IconLocation } from '@americanexpress/dls-icons';
import Banner from '../Banner/Banner';

import style from './MarketingTileImage.scss';

const MarketingTileImage = ({
  image, caption, title, isBottomTile,
}) => !!image && (
  <div
    data-testid="marketing-tile-image"
    className={clsx(
      'position-relative margin-b radius-container-sm',
      isBottomTile ? style.bottomImageContainer : style.sideImageContainer
    )}
    style={{ backgroundImage: `url('${image}')` }}
  >
    {!!caption && (
      <div
        className={`${style.locationTag} position-absolute dls-white flex margin-1 pad-1 radius-container-sm`}
      >
        <IconLocation color="white" size="md" />
        <p className="pad-1-l">{caption}</p>
      </div>
    )}
    <Banner content={title} />
  </div>
);
MarketingTileImage.propTypes = {
  image: PropTypes.string,
  caption: PropTypes.string,
  title: PropTypes.string,
  isBottomTile: PropTypes.bool,
};

MarketingTileImage.defaultProps = {
  image: '',
  caption: '',
  title: '',
  isBottomTile: false,
};

export default MarketingTileImage;
